import { handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/myInfo";

const APPLY_INFO = "myinfo/USER_INFO"; // 내 자원서 정보
// const APPLY_INFO_PENDING = "myinfo/USER_INFO_PENDING";
const APPLY_INFO_SUCCESS = "myinfo/USER_INFO_SUCCESS";

const APPLY_MODIFY = "myinfo/APPLY_MODIFY";

export const applyInfoData = createPromiseThunk(APPLY_INFO, api.applyInfo);
export const applyModify = createPromiseThunk(APPLY_MODIFY, api.applyModify);

const initialState = {
  applyData: null,
  sickList: null,
  sbjCondList: null,
  sbjTyList: null,
  langList: null
};

export default handleActions(
  {
    // [APPLY_INFO_PENDING]: (state, { payload }) => ({
    //   ...state,
    //   applyData: null
    // }),
    [APPLY_INFO_SUCCESS]: (state, { payload }) => ({
      ...state,
      applyData: payload.data.user,
      sickList: payload.data.sickList,
      sbjCondList: payload.data.sbjCondList,
      sbjTyList: payload.data.sbjTyList,
      langList: payload.data.langList
    })
  },
  initialState
);
